import React, { useState, useEffect, useRef } from "react";
import { Input, Checkbox, Button, Spin } from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { useTranslation } from "react-i18next";

const AddGroupProduct_Modal = ({ open, onClose, onSave, groups, activeGroupId, activeSubgroupId }) => {
    const { t, i18n } = useTranslation();
    const [searchQuery, setSearchQuery] = useState("");
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const userData = useSelector((state) => state?.login?.user?.result);
    const group = groups?.find(g => g.id === activeGroupId);
    const selectedGroup = activeSubgroupId
  ? group?.sub_group_list?.find((s) => s.id === activeSubgroupId)
  : group;

    // console.log("AGGAGDGDGD", groups);
    // console.log("group", group);
    const dropdownRef = useRef(null);
    const toggleBtnRef = useRef(null);
    
    
      useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target) &&
          toggleBtnRef.current &&
          !toggleBtnRef.current.contains(event.target)
        ) {
          setShowDropdown(false);
        }
      };
    
      if (showDropdown) {
        document.addEventListener("mousedown", handleClickOutside);
      }
    
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showDropdown]);



    // Fetch products for the given group
 const getProducts = async (val = "") => {
    setLoading(true);
    try {
      const payload = {
        company_id: userData?.company_id,
        product_name: val,
        barcode: "",
        limit: 10,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await axiosInstance.post(URLS.GET_PRODUCT_SEARCH, payload);
      const result = res?.data?.result?.[0]?.response || [];
      setProducts(result);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

    
    // Debounced search
    useEffect(() => {
          if (!open && !group) return;
        const timer = setTimeout(() => {
            if (searchQuery.length === 0 || searchQuery.length > 2)
                getProducts(searchQuery);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchQuery,group]);

    const toggleProduct = (id) => {
        setSelectedProducts((prev) =>
            prev.includes(id)
                ? prev.filter((pid) => pid !== id)
                : [...prev, id]
        );
    };

    const handleClose = () => {
        setSearchQuery("");
        setSelectedProducts([]);
        setShowDropdown(false);
        onClose?.();
    };

    const handleSave = async () => {
        if (selectedProducts.length === 0) {
            toast.error(t("Please select at least one product."));
            return;
        }

        setProcessing(true);

        try {
            const payload = {
                user_id: userData?.user_id,
                company_id: userData?.company_id,
                group_id: activeSubgroupId || activeGroupId,
                add_product_ids: selectedProducts,
            };

            // Call the API to save the changes
            const res = await axiosInstance.post(URLS.EDIT_PRODUCT_GROUP, payload);

            // Check if the response status code is 200 and the status is "Product Group Updated"
            if (res?.data?.result?.[0]?.status_code === 200 && res?.data?.result?.[0]?.status === "Product Group Updated") {
                toast.success(t("Products added successfully."));
                onSave?.(); // Callback to notify parent component of success
                handleClose(); // Close the modal
                setProcessing(false);
            } else {
                // If the response status is not what we expect, show an error message
                toast.error("Failed to add products.");
                setProcessing(false);
            }
        } catch (err) {
            console.error("Error saving products:", err);
            toast.error("Error saving products.");
            setProcessing(false);
        }
    };

    if (!open) return null; // hide modal when closed

    return (
        <>
            {processing && <LoadingSpinner />}
            <div
                className="fixed inset-0 z-[9999] flex items-center justify-center"
                style={{
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(0,0,0,0.4)",
                }}
            >
                {/* Modal container */}
                <div className="relative w-[900px] bg-white rounded-[20px] p-10 shadow-2xl animate-fadeIn">
                    {/* Close Button (optional) */}
                    <button
                        onClick={handleClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl font-semibold"
                    >
                        ×
                    </button>

                    {/* Title */}
                    <h2 className="text-3xl font-bold mb-6">{t("Add Products to")} {selectedGroup?.name}</h2>

                    {/* Display Existing Group Name */}
                    {/* <div className="mb-8">
                    <h3 className="text-xl font-semibold mb-4 text-gray-600">
                        Group Name
                    </h3>
                    <div className="grid grid-cols-2 gap-6">
                        <div className="flex items-center">
                            <span className="text-lg text-gray-600">{group?.name}</span>
                        </div>
                    </div>
                </div> */}

                    {/* Product Dropdown Section */}
                    <div className="mb-8 relative">
                        <label className="block text-xl mb-2 font-semibold text-gray-600">
                            {t("Product List")}
                        </label>

                        <button
                         ref={toggleBtnRef}
                            onClick={() => setShowDropdown(!showDropdown)}
                            className="w-full flex items-center justify-between border border-gray-300 rounded-xl h-12 px-4 text-lg focus:outline-none"
                        >
                            <span>
                                {selectedProducts.length > 0
                                    ? `${selectedProducts.length} ${t("selected")}`
                                    : (t("Select products"))}
                            </span>
                            <DownOutlined
                                className={`transition-transform ${showDropdown ? "rotate-180" : ""
                                    }`}
                            />
                        </button>

                        {showDropdown && (
                            <div
                ref={dropdownRef}
                                className="absolute z-50 left-0 right-0 bg-white border border-gray-200 rounded-xl shadow-lg w-full mt-2 overflow-y-auto p-4 custom-scrollbar"
                                style={{ maxHeight: "400px" }}
                            >
                                <Input
                                    prefix={<SearchOutlined />}
                                    placeholder={t("Search products...")}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="mb-3 text-lg h-10 rounded-lg focus:outline-none"
                                    suffix={
                                        searchQuery && (
                                            <span
                                                onClick={() => setSearchQuery("")}
                                                className="cursor-pointer text-gray-400 hover:text-gray-600 text-xl font-semibold"
                                            >
                                                ×
                                            </span>
                                        )
                                    }
                                />

                                {loading ? (
                                    <div className="flex justify-center text-lg py-4">
                                        <Spin />
                                    </div>
                                ) : (products.length > 0 && searchQuery.length > 1) ? (
                                    <>
                                        {/* {products.map((p) => (
                                            <div
                                                key={p.prod_id}
                                                onClick={() => {
                                                    if (!p.is_grouping) {
                                                        toggleProduct(p.prod_id); // Only toggle if the product is not in a group
                                                    }
                                                }}
                                                className={`flex items-center py-2 px-2 rounded-lg cursor-pointer hover:bg-green-50 ${selectedProducts.includes(p.prod_id)
                                                    ? "bg-green-50"
                                                    : ""
                                                    } ${p.is_grouping ? "opacity-50 cursor-not-allowed" : ""}`}
                                            >
                                                <Checkbox
                                                    checked={selectedProducts.includes(p.prod_id)}
                                                    onChange={() => {
                                                        if (!p.is_grouping) {  // Prevent selection if product is part of a group
                                                            toggleProduct(p.prod_id);
                                                        }
                                                    }}
                                                    disabled={p.is_grouping} // Disable already added products
                                                >
                                                    <span className="ms-2 text-gray-800 text-base">
                                                        {p.name} {p.is_grouping && <span className="ms-2 text-red-500">{t("(Already in Group)")}</span>}
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        ))} */}
                                        {products.map((p) => (
                                            <div
                                                key={p.prod_id}
                                                onClick={(e) => {
                                                    // Only toggle selection if it's not a group and click is not on the checkbox
                                                    if (!p.is_grouping && e.target.type !== 'checkbox') {
                                                        toggleProduct(p.prod_id);
                                                    }
                                                }}
                                                className={`flex items-center py-2 px-2 rounded-lg cursor-pointer hover:bg-green-50 ${selectedProducts.includes(p.prod_id) ? "bg-green-50" : ""} ${p.is_grouping ? "opacity-50 cursor-not-allowed" : ""}`}
                                            >
                                                <Checkbox
                                                    checked={selectedProducts.includes(p.prod_id)}
                                                    onChange={() => {
                                                        if (!p.is_grouping) {
                                                            toggleProduct(p.prod_id); // Toggle selection when the checkbox is clicked
                                                        }
                                                    }}
                                                    disabled={p.is_grouping} // Disable checkbox for products in groups
                                                    onClick={(e) => e.stopPropagation()} // Stop click from bubbling to parent div
                                                >
                                                    <span className="ms-2 text-gray-800 text-base">
                                                        {p.name} {p.is_grouping && <span className="ms-2 text-red-500">{t("(Already in Group)")}</span>}
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        ))}


                                    </>
                                ) : (
                                    <>
                                    {searchQuery.length > 1 &&
                                     <p className="text-center text-gray-400 py-4">
                                        {t("No products found")}
                                    </p>}
                                    </>
                                   
                                )}
                            </div>
                        )}
                    </div>

                    {/* Save Button */}
                    <div className="flex justify-end gap-4 ">
          <button
            onClick={handleClose}
            className={`px-8 py-2 font-semibold text-lg border rounded-lg bg-white text-[#8DC63F] border-[#8DC63F]`}
          >
            {t("Cancel")}
          </button>
          <button
          onClick={handleSave}
            className={`px-10 py-2 font-semibold text-lg border rounded-lg bg-[#8DC63F] text-white border-[#8DC63F] `}
          >
            {t("Save")}
          </button>
        </div>
                    {/* <Button
                        block
                        onClick={handleSave}
                        className="!h-14 !text-lg !font-semibold !rounded-2xl !bg-[#8DC63F] !text-white hover:!bg-[#7CB82F] hover:!text-white focus:outline-none"
                    >
                        {t("Save")}
                    </Button> */}
                </div>
            </div>
        </>
    );
};

export default AddGroupProduct_Modal;
